module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "drag",
      rawName: "v-drag.x",
      value: (!_vm.tab.fixed),
      expression: "!tab.fixed",
      modifiers: {
        "x": true
      }
    }, {
      name: "drag",
      rawName: "v-drag:start",
      value: (_vm.onDragstart),
      expression: "onDragstart",
      arg: "start"
    }, {
      name: "drag",
      rawName: "v-drag:move",
      value: (_vm.onDrag),
      expression: "onDrag",
      arg: "move"
    }, {
      name: "drag",
      rawName: "v-drag:end",
      value: (_vm.onDragend),
      expression: "onDragend",
      arg: "end"
    }],
    staticClass: "tab",
    class: {
      'tab-active': _vm.tab.id === _vm.activeId,
        'is-moving': _vm.isMoving,
        'is-not-moving': !_vm.isMoving && _vm.hasTabMoving
    },
    style: ({
      width: (_vm.width + "px"),
      transform: _vm.tab.fixed ?
        'none' : ("translateX(" + (_vm.tab.moveOffset) + "px)")
    }),
    on: {
      "click": _vm.activate
    }
  }, [_c('span', {
    staticClass: "tab-label",
    attrs: {
      "title": _vm.tab.label
    }
  }, [_c('span', {
    staticClass: "tab-label-container",
    style: ({
      transform: ("translateX(" + (-_vm.labelTranslate) + "px)")
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activate($event)
      },
      "mouseenter": function($event) {
        $event.stopPropagation();
        _vm.onLabelOver($event)
      },
      "mouseleave": function($event) {
        $event.stopPropagation();
        _vm.onLabelLeave($event)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.tab.label) + "\n        ")])]), _vm._v(" "), (!_vm.tab.fixed) ? _c('span', {
    staticClass: "tab-close tofu-icon icon-close",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.destroy($event)
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5396a7fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/new-tabbar/src/tab.vue
// module id = 647
// module chunks = 0